module.exports = __webpack_public_path__ + "img/choose_img1.e0272bbf.png";